module.exports = __webpack_public_path__ + "img/hybl-icon.01650ef3.png";